/**
 * Generated by orval v7.3.0 🍺
 * Do not edit manually.
 * Tournated Dashboard API
 * Internal REST API consumed by the Tournated dashboard. Authenticated with a user JWT (Authorization: Bearer ...).
 * OpenAPI spec version: 1.0
 */

/**
 * How the league resolves its Sporfie key: inherit the platform key (`use_platform_key`), use its own `sporfieKey` (`custom_key`), or disable Sporfie (`disabled`).
 */
export type SporfieMode = (typeof SporfieMode)[keyof typeof SporfieMode];

export const SporfieMode = {
  use_platform_key: "use_platform_key",
  custom_key: "custom_key",
  disabled: "disabled",
} as const;
